import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import { Helmet } from "react-helmet";
import clsx from "classnames";
import classes from "./styles.module.scss";

export const Form = ({ className, formId = null, onSubmitDone = () => {} }) => {
  if (!formId) return null;

  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css"
        />
      </Helmet>
      <div className={clsx(className, classes.form)}>
        <SourceFlowForm formId={formId} onSubmitDone={onSubmitDone} />
      </div>
    </>
  );
};

export default Form;
